var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoneMarkIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.6.1-Onboarding---Departments---Define-New-Department",
    transform: "translate(-860.000000, -394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2-Copy",
    transform: "translate(851.000000, 386.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68961202,1.00102932e-13 C11.9364675,1.00102932e-13 15.379224,3.44275657 15.379224,7.68961202 C15.3745153,11.9345155 11.9345155,15.3745153 7.68961202,15.379224 C3.44275657,15.379224 -4.12637245e-13,11.9364675 -4.12637245e-13,7.68961202 C-4.12637245e-13,3.44275657 3.44275657,1.00102932e-13 7.68961202,1.00102932e-13 Z M11.3840434,4.92391489 L6.86084272,9.07032457 L4.87606842,7.08555027 C4.66155006,6.86344302 4.34388072,6.77436654 4.04515686,6.85255746 C3.74643301,6.93074837 3.51314303,7.16403835 3.43495212,7.4627622 C3.3567612,7.76148606 3.44583768,8.0791554 3.66794493,8.29367376 L6.23114894,10.8568778 C6.55463594,11.1804159 7.0755735,11.1917161 7.41278598,10.8825098 L12.539194,6.18330246 C12.7641619,5.97695468 12.8619556,5.66626251 12.7957372,5.36826068 C12.7295187,5.07025886 12.5093482,4.83022095 12.2181619,4.7385669 C11.9269755,4.64691286 11.6090113,4.71756711 11.3840434,4.92391489 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoneMarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doneMarkIcon.bd6b5e590c497132a20a72d91665457d.svg";